/**
 * Check if user is already being tracked/ignored, if not assign them to a group.
 * Group assignment is handled via sessionStorage.
 * @param {String} sessionId
 */
const setWsTrackingUser = (sessionId = '') => {
	// Check if user is already being tracked/ignored, if not assign them to a group.
	// Note, will need to replace getting the sessionId from the datalayer.
	const trackPercentage = 10;
	if (sessionStorage?.getItem('wsTrackingUser') === null) {
		if (Math.floor(Math.random() * (100 - 0) + 1) <= trackPercentage) {
			sessionStorage?.setItem('wsTrackingUser', 'track');
			sessionStorage?.setItem('wsTrackingSessionId', sessionId);
		} else {
			sessionStorage?.setItem('wsTrackingUser', 'ignore');
		}
	}
};

export default setWsTrackingUser;
